import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SpecificationConfirmClaimsState } from '../../types/specification-confirm-claims';
import type { SpecificationConfirmClaimsModel } from '../specification-confirm-claims-model';

@injectable()
export class SpecificationConfirmClaimsModelImpl extends AbstractModel<SpecificationConfirmClaimsState> implements SpecificationConfirmClaimsModel {
    protected _modelData: SpecificationConfirmClaimsState = {
        taskId: '',
        loading: false,
        loadingSubmit: false,
        formData: {
            formattedClaim: {
                content: '',
                status: null,
            },
            claimTree: {
                content: [],
                status: null,
            },
        },
    };

    get modelData(): SpecificationConfirmClaimsState {
        return this._modelData;
    }
}
